import Paginator from "./Paginator";
import ActiviteFilters from "./ActiviteFilters"
import ActiviteGrid from "./ActiviteGrid"

export default ({titleBar}) => {
    const perPage = 9;
    const {apiFetch} = wp;
    const {useState,useEffect,Fragment} = React;
    const [hasToLoadUrl,setHasToLoadUrl] = useState(false);
    const [isLoading,setIsLoading] = useState(true);
    const [page,setPage] = useState(1);
    const [totalPages,setTotalPages] = useState(1);
    const [activities,setActivite] = useState([]);
    const [terms,setTerms] = useState([]);
    const [selectedTerms,setSelectedTerms] = useState([]);
    const [defaultTitle,setDefaultTitle] = useState("");

    const loadURLType = ()=>{
        if(hasToLoadUrl){
            const params = new URLSearchParams(document.location.search);
            if(params.has('type')){
                const type = params.get('type');
                const validTerms = terms.filter(term=>term.slug == type);
                setSelectedTerms(validTerms.map(term=>term.id));
            }
            setHasToLoadUrl(false);
        }
    }

    const getTypes = () => {
        apiFetch({ path:'wp/v2/category_activity' , parse: false })
        .then( res  => res.json())
        .then( json => {
            setHasToLoadUrl(true);
            setTerms(json);
        })
    }

    const setTitle = () =>{
        if(titleBar){
            let title = defaultTitle;
            if(selectedTerms.length > 0){
                title += " | ". selectedTerms[0]
            }
        }
    }

    const loadActivites = () => {
        setIsLoading(true);
        const query = {
            page:page,
            per_page:perPage,
            orderby:'date'
        };

        if(selectedTerms.length > 0 ) {
            query.category_activity = selectedTerms
        }

        const queryURL = new URLSearchParams( query ).toString();
        
        apiFetch({ path:'wp/v2/activities?'+ queryURL, parse: false })
        .then ((res)=>{
            const headers = res.headers;
            res.json().then((json)=>{
                setTotalPages(headers.get('x-wp-totalpages'))
                setActivite(json)
                setIsLoading(false);
            })
        })
    }

    useEffect(()=>{
        setPage(1);
        loadActivites();
    },[selectedTerms])
    useEffect(()=>{
        if(titleBar){
            setDefaultTitle(titleBar.innerHTML);
        }
    },[]);
    useEffect(loadActivites,[page])
    useEffect(getTypes,[])
    useEffect(loadURLType,[terms])

    return (
        <Fragment>
            <ActiviteFilters terms={terms} selectedTerms={selectedTerms} setSelectedTerms={setSelectedTerms} />
            <ActiviteGrid activities={activities} isLoading={isLoading} />
            {totalPages > 1 &&
                <Paginator page={page} totalPages={totalPages} setPage={setPage} />
            }
        </Fragment>
    )
}